// Imports
import styled from "styled-components"

import { Variables, Mixins } from "fajny-react"

const Container = styled.footer`
    position: relative;
    z-index: 10;
    background-color: ${Variables.Colors.Background};
    padding: ${Variables.Spacers.XXL} 5% ${Variables.Spacers.L};
    ${Mixins.Flexbox({
        $align: "center",
        $justify: "space-between",
    })};

    &:before {
        content: "";
        position: absolute;
        top: ${Variables.Spacers.L};
        left: 5%;
        width: 90%;
        height: 1px;
        background-color: ${Variables.Colors.Gray200};
    }

    @media ${Variables.Breakpoints.Mobile} {
        flex-direction: column;
        gap: ${Variables.Spacers.XS};

        & > p {
            text-align: center;
        }
    }
`

const Col = styled.div`
    ${Mixins.Flexbox({
        $align: "center",
        $justify: "flex-start",
        $gap: "xs",
    })};

    a {
        position: relative;
        top: 3px;
        color: ${Variables.Colors.Primary500};
        text-decoration: none;
        transition: ${Variables.Transitions.Short};

        &:hover {
            color: ${Variables.Colors.Primary300};
        }

        &:active {
            color: ${Variables.Colors.Primary600};
        }
    }
`

export { Container, Col }
